export default class importOvatBillModalContentCtrl {
    constructor($scope, $uibModalInstance, items1, httpRequest) {
        $scope.modalData = items1
        // 拆分结果分页参数
        $scope.pageModalImportOpt = {
            totalItems: $scope.modalData.splitResult.total, // 组件初始化设置总页数
            currentPage: ++$scope.modalData.splitResult.prePage, // 设置显示第一页
            maxSize: $scope.modalData.splitResult.pageSize, // 每一页显示记录数
        }
        // 页码操作
        $scope.pageModalImportChanged = function () {
            const _req = {
                pageNum: $scope.pageModalImportOpt.currentPage,
                pageSize: $scope.pageModalImportOpt.maxSize,
                param: $scope.modalData.batchNo,
            }
            httpRequest.post_getBillSplitCountList(_req).then((res) => {
                $scope.modalData.splitResult = res.data.value
                $scope.pageModalImportOpt = {
                    totalItems: $scope.modalData.splitResult.total,
                    currentPage: ++$scope.modalData.splitResult.prePage,
                    maxSize: $scope.modalData.splitResult.pageSize,
                }
            })
        }

        // 关闭
        $scope.cancel = function () {
            $uibModalInstance.dismiss('cancel')
        }
        // 导出
        $scope.exportSplitResult = function () {
            // 返回数据
            const _res = {
                splitResult: {},
            }
            window.open(`${host.etcloudOvat}/ovatInvoiceWait/exportBillSplitCountList?batchNo=${$scope.modalData.batchNo}&accessToken=${$scope.modalData.idToken}`)
            $uibModalInstance.close(_res)
        }
    }
}
importOvatBillModalContentCtrl.$inject = ['$scope', '$uibModalInstance', 'items1', 'httpRequest']



// WEBPACK FOOTER //
// ./src/app/outputManage/fillOpenManage/ovatBill/splitResultCtrl.js